import { render } from "./CocktailTwo.vue?vue&type=template&id=a72d43be"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CocktailTwo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a72d43be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a72d43be', __exports__)) {
    api.reload('a72d43be', __exports__)
  }
  
  module.hot.accept("./CocktailTwo.vue?vue&type=template&id=a72d43be", () => {
    api.rerender('a72d43be', render)
  })

}


export default __exports__